import { QualificationStatus } from "@/api/williams/welders";

const StatusText: Record<number, string> = {
  [QualificationStatus.NotFound]: "Not found",
  [QualificationStatus.Ineligible]: "Ineligible",
  [QualificationStatus.NoQualifications]: "No Qualifications",
  [QualificationStatus.Current]: "Current",
  [QualificationStatus.SomeExpired]: "Some Expired",
  [QualificationStatus.AllExpired]: "Expired",
  [QualificationStatus.SomeRevoked]: "Some Revoked",
  [QualificationStatus.AllRevoked]: "Revoked",
};

export function getStatusText(status: QualificationStatus) {
  return StatusText[status];
}
